import React from "react";
import styled from 'styled-components';
import PopupLink from "../../PopupLink";

const MainHeader = styled.h1`
  font-size: 1.5em;
`
const SubHeader = styled.h2`
  font-size: 1em;
`
const Content = styled.p`
  font-size: 0.8em;
`

const PopupContent = () => (
  <div>
    <MainHeader> Identification </MainHeader>
    <SubHeader> What identification will I need at check-in? </SubHeader>
    <Content>
      The documentation you'll need will vary depending upon your citizenship and
      your destination.
    </Content>
    <SubHeader> Travel within the U.S. and U.S. Territories </SubHeader>
    <Content>
      <strong> U.S. citizens </strong> (18 and over) traveling within the U.S.
      will require a government issued photo ID. U.S. citizens under the age of
      18 are not required to provide an ID at the airport security checkpoint.
    </Content>
    <Content>
      <strong> Non-US/Canadian citizens </strong> are not required to carry
      their passports if they have documents issued by the U.S. government such
      as Permanent Resident Cards. Those who do not should carry their passports
      while visiting the U.S.
    </Content>
    <SubHeader> International Travel </SubHeader>
    <Content>
      All International travelers will need a valid passport, and may also need to
      show additional documentation at the destination and/or in connecting
      countries. In addition, all travelers must have the proper documents for
      entry/re-entry into a country (i.e. correct visa, valid passport,
      onward/return ticket). For international one-way travel, proof of return
      travel or onward travel may be required and children travelling without both
      parents may also require additional documentation. If you are unsure of the
      travel requirements for your destination, please contact the embassy or
      consulate of all countries you are traveling to and connecting through.
    </Content>
  </div>
);

const GovtIssuedIDLink = () => {
  return (
    <PopupLink
      linkText="government-issued photo ID"
      popupContent={<PopupContent />}
    />
  );
}

export default GovtIssuedIDLink;



// WEBPACK FOOTER //
// ./src/components/ImportantInformation/GovtIssuedIDLink/index.js